import { isApiError } from "@design-lab/shared/lib/errorGuards";

export const isClientError = (error: unknown): boolean => {
  if (!isApiError(error)) return false;
  const status = error.response?.status;
  return typeof status === "number" && status >= 400 && status < 500;
};
